import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { getUrlKey } from '../utils/utils';
const lang_zh = require('./zh.json');
const lang_en = require('./en.json');

Vue.use(VueI18n);

const DEFAULT_LANG = 'zh';
const LOCALE_KEY = 'localeLanguage';

const locales = {
  zh: lang_zh,
  en: lang_en,
};

const i18n = new VueI18n({
  locale: DEFAULT_LANG,
  messages: locales,
});

const urlLang = getUrlKey('language');

export const setupLang = (lang) => {
  if (lang === undefined) {
    lang = window.localStorage.getItem(LOCALE_KEY);
    if (urlLang) {
      lang = urlLang === 'en-US' ? 'en' : 'zh';
    }
    if (locales[lang] === undefined) {
      lang = DEFAULT_LANG;
    }
  }
  window.localStorage.setItem(LOCALE_KEY, lang);

  Object.keys(locales).forEach((lan) => {
    document.body.classList.remove(`lang-${lan}`);
  });
  document.body.classList.add(`lang-${lang}`);
  document.body.setAttribute('lang', lang);

  Vue.config.lang = lang;
  i18n.locale = lang;
};

setupLang();
export default i18n;
